/**
 * Sidebar Accordion Component
 * Reusable accordion for sidebar sections
 *
 * @package
 */

import { useState, useId } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import Icon from './Icon';

const SidebarAccordion = ( { title, children, defaultOpen = true, id, description, readMoreUrl, className = '' } ) => {
	const [ isOpen, setIsOpen ] = useState( defaultOpen );
	const generatedId = useId();

	const accordionId = id || `sidebar-accordion${ generatedId }`;
	const contentId = `${ accordionId }-content`;

	return (
		<div className={ `configurator-sidebar-accordion ${ className }`.trim() }>
			<button
				type="button"
				className="configurator-sidebar-accordion-header"
				onClick={ () => setIsOpen( ! isOpen ) }
				aria-expanded={ isOpen }
				aria-controls={ contentId }
				id={ accordionId }
			>
				<h2 className="configurator-sidebar-section-title">{ title }</h2>
				<Icon
					name={ isOpen ? 'minus' : 'plus' }
					className="configurator-accordion-icon"
					size="small"
				/>
			</button>
			{ isOpen && (
				<div
					id={ contentId }
					className="configurator-sidebar-accordion-content"
					role="region"
					aria-labelledby={ accordionId }
				>
					{ description && (
						<div
							className="configurator-sidebar-accordion-description"
							dangerouslySetInnerHTML={ { __html: description } }
						/>
					) }
					{ readMoreUrl && (
						<a
							href={ readMoreUrl }
							className="configurator-sidebar-accordion-read-more"
							target="_blank"
							rel="noopener noreferrer"
						>
							{ __( 'Read More', 'at-vehicle-configurator' ) }
							<Icon name="arrow-right" width={ 17 } height={ 15 } className="configurator-sidebar-accordion-read-more-arrow" />
						</a>
					) }
					{ children }
				</div>
			) }
		</div>
	);
};

export default SidebarAccordion;
